var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.013,
    height: 25.932,
    viewBox: "0 0 40.013 25.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-466.691 -4697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.482-1125.831c.094-.026.1-.117.121-.185a2.59,2.59,0,0,1,2.572-1.835h.156q17.154,0,34.308,0a2.628,2.628,0,0,1,2.478,1.263,2.553,2.553,0,0,1-2.174,3.878c-.143.007-.286,0-.43,0H22.478a2.641,2.641,0,0,1-2.919-1.95c-.013-.031-.051-.052-.077-.078Z",
    transform: "translate(447.209 5824.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.482-811.438c.172-.13.147-.349.232-.519a2.6,2.6,0,0,1,2.334-1.507c.091-.005.182,0,.274,0q17.174,0,34.347,0a2.6,2.6,0,0,1,2.463,1.287,2.56,2.56,0,0,1-2.259,3.857c-.078,0-.156,0-.234,0q-17.154,0-34.308,0a2.665,2.665,0,0,1-2.611-1.506c-.085-.17-.069-.386-.238-.516Z",
    transform: "translate(447.209 5531.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.482-968.652c.168-.131.151-.347.236-.517a2.634,2.634,0,0,1,2.569-1.507q7.814,0,15.628,0c1.511,0,3.022-.011,4.532,0a2.565,2.565,0,0,1,2.664,2.8,2.573,2.573,0,0,1-2.664,2.334c-1.654.012-3.308,0-4.962,0H22.521a2.65,2.65,0,0,1-2.961-1.947c-.013-.031-.052-.052-.078-.077Z",
    transform: "translate(447.209 5678.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.508-965.83c-.816-.056-1.633.043-2.451-.075a2.532,2.532,0,0,1-2.145-2.53,2.469,2.469,0,0,1,2.144-2.48,27.527,27.527,0,0,1,4.938,0,2.523,2.523,0,0,1,2.14,2.5A2.6,2.6,0,0,1,341-965.906C340.167-965.785,339.337-965.887,338.508-965.83Z",
    transform: "translate(163.57 5678.383)",
    fill: "#f0efef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggle);
export default __webpack_public_path__ + "static/media/menu-toggle.fbeea18ab121496ca9e75694bd7478c4.svg";
export { ForwardRef as ReactComponent };